import React from "react";
import DatePicker from "react-datepicker";
import DateTimeHelper from "shared/utils/dateTimeHelper";
import { DateTimePickerConfig } from "../types";
import { YEAR_SELECTOR_ID } from "shared/utils/constants";

export default function useDatePickerService(props: DateTimePickerConfig) {
  const ref = React.useRef<DatePicker>(null);

  const dateTimeFormat = React.useMemo(
    () => DateTimeHelper.getFormatString(props.formattingOptions),
    [props.formattingOptions]
  );

  const showTimeInput = React.useMemo(
    () => props.formattingOptions?.showTime || props.formattingOptions?.showOnlyTime,
    [props.formattingOptions?.showOnlyTime, props.formattingOptions?.showTime]
  );

  const closeOnScrollHandler = React.useCallback((e: any) => {
    if (
      e.target.classList?.value?.includes("selectDropdown__menu-list") ||
      e.target.classList?.value?.includes("scrollableTimePicker")
    ) {
      // It is Time Selector scroll, so don't close
      return false;
    }
    return (e.target?.id || "") !== YEAR_SELECTOR_ID;
  }, []);

  const closeDatePickerHandler = React.useCallback(() => {
    ref.current?.setOpen(false);
  }, []);

  const openDatePickerHandler = React.useCallback(() => {
    ref.current?.setOpen(true);
  }, []);

  return {
    ref,
    dateTimeFormat,
    showTimeInput,
    closeOnScrollHandler,
    closeDatePickerHandler,
    openDatePickerHandler
  };
}
